export default __webpack_public_path__ + "static/media/NotoSans-Regular.3aa6f142.ttf";